import {commentator} from '@utilities/sal-commentator/sal-commentator';
import {breakpoints} from '@utilities/sal-breakpoint/sal-breakpoint';
import {animation} from '@utilities/sal-animation/sal-animation';

const CONSTANTS = {
    CONTENT_NAVIGATION_CLASS: '.content-navigation__container',
    CONTENT_NAVIGATION_TITLE_CLASS: '.content-navigation__title',
    CONTENT_NAVIGATION_CONTENT_CLASS: '.content-navigation__content',
    CONTENT_NAVIGATION_ICON_CLASS: '.icon-toggle',
    CONTENT_NAVIGATION_EXPANDED: 'minus',
    CONTENT_NAVIGATION_COLLAPSED: 'plus',
    CONTENT_NAVIGATION_BODY_SHOW: 'animation__direction--reverse',
    CONTENT_NAVIGATION_BODY_HIDE: 'animation__direction--forwards',
    KEYVISUAL_CLASS: '.keyvisual .gallery__single, .video-keyvisual .video-keyvisual__image',
    SIMULATED_CLICK: 'simulated'
};

const eventHandler = {
    repositionContentNavigation: () => {
        const contentNavigationElement = document.querySelector(CONSTANTS.CONTENT_NAVIGATION_CLASS);
        const keyvisualElement = document.querySelector(CONSTANTS.KEYVISUAL_CLASS);

        if (contentNavigationElement && keyvisualElement) {
            try {
                contentNavigationElement.style.top = `${keyvisualElement.clientHeight}px`;
                commentator.insertCommentBefore(contentNavigationElement, 'landingpage.js', commentator.getPresets().STYLE);
            }
            catch {
                commentator.insertCommentBefore(contentNavigationElement, 'landingpage.js', 'Failed to set style *top*');
            }
        }
    },
    toggleNavigationContent: (simulated) => {
        if (simulated === CONSTANTS.SIMULATED_CLICK) {
            let simulatedClick = new CustomEvent('simulatedClick');
            const contentNavTitle = document.querySelector(`.${animationOptions.classes.trigger}`);
            if (contentNavTitle) {
                contentNavTitle.dispatchEvent(simulatedClick);
            }
        }

        const navigationIconElement = document.querySelector(CONSTANTS.CONTENT_NAVIGATION_ICON_CLASS);
        if (navigationIconElement) {
            if (navigationIconElement.classList.contains(CONSTANTS.CONTENT_NAVIGATION_COLLAPSED)) {
                navigationIconElement.classList.remove(CONSTANTS.CONTENT_NAVIGATION_COLLAPSED);
                navigationIconElement.classList.add(CONSTANTS.CONTENT_NAVIGATION_EXPANDED);

            } else {
                navigationIconElement.classList.remove(CONSTANTS.CONTENT_NAVIGATION_EXPANDED);
                navigationIconElement.classList.add(CONSTANTS.CONTENT_NAVIGATION_COLLAPSED);
            }
        }

        //eventHandler.transitionTrigger();
    },
    checkNavigationVisibility: () => {
        const navigationIconElement = document.querySelector(CONSTANTS.CONTENT_NAVIGATION_ICON_CLASS);
        if (navigationIconElement) {
            if (window.innerWidth > breakpoints.lg) {
                if (navigationIconElement.classList.contains(CONSTANTS.CONTENT_NAVIGATION_COLLAPSED)) {
                    eventHandler.toggleNavigationContent(CONSTANTS.SIMULATED_CLICK);
                }
            } else {
                if (navigationIconElement.classList.contains(CONSTANTS.CONTENT_NAVIGATION_EXPANDED)) {
                    eventHandler.toggleNavigationContent(CONSTANTS.SIMULATED_CLICK);
                }
            }
        }
    }
};

const animationOptions = {
    eventType: 'click',
    findTarget: CONSTANTS.MODE_CLOSEST,
    directions: 'next',
    classes: {
        trigger: 'content-navigation__title',
        target: 'content-navigation__content',
        parent: 'content-navigation__title'
    },
    animation: {
        duration: 'animation__duration--500',
        type: 'animation__type--expand',
        forwards: CONSTANTS.CONTENT_NAVIGATION_BODY_HIDE,
        reverse: CONSTANTS.CONTENT_NAVIGATION_BODY_SHOW,
        toggle: 'true'
    }
};

const landingpage = {
    init: () => {
        animation.init(animationOptions);

        window.addEventListener("resize", eventHandler.repositionContentNavigation);
        window.addEventListener("imageLoaded", eventHandler.repositionContentNavigation);
        eventHandler.repositionContentNavigation();

        if (window.innerWidth > breakpoints.lg) {
            eventHandler.toggleNavigationContent(CONSTANTS.SIMULATED_CLICK);
        }

        //eventHandler.transitionTrigger();
        //document.querySelector(CONSTANTS.CONTENT_NAVIGATION_CONTENT_CLASS).addEventListener('transitionend', eventHandler.transitionTrigger);
        const navElement = document.querySelector(CONSTANTS.CONTENT_NAVIGATION_TITLE_CLASS);
        if (navElement) {
            navElement.addEventListener('click', eventHandler.toggleNavigationContent);
        }
        window.addEventListener('resize', eventHandler.checkNavigationVisibility);
    }
};

export { landingpage };
